<template>
  <div>
    <div class="form-group">
      <div id="card-element" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-6">
        <div class="form-group">
          <div id="card-year" class="form-control"></div>
        </div>
      </div>
      <div class="col-sm-6 col-6">
        <div class="form-group">
          <div id="card-cvc" class="form-control"></div>
        </div>
      </div>
    </div>
    <button v-on:click="buyPremium"
            :disabled="isLoading"
            class="btn btn-main w-100">
      {{ isLoading ? $lang.messages.get_premium_modal.wait_please : $lang.messages.get_premium }}
    </button>
  </div>
</template>
<script>

import {loadStripe} from '@stripe/stripe-js';
import firebase from "firebase/app";
import {API_HOST, STRIPE_KEY, STRIPE_KEY_TEST} from "@/helpers/stipe_const";
import {createSubscription, createCustomerStripe, addToActiveCampaignPremiumList} from '../helpers/api'

let cardElement = null;
let cardCvc = null;
let cardExpiry = null;
export default {
  name: 'stripeView',
  props: ['premiumPlan', 'customer', 'trial'],
  data: function () {
    return {
      prices: [],
      isPremiumPurchased: false,
      clientSecret: null,
      user: null,
      selectedPrice: null,
      isLoading: false,
      userCustomer: null,
      testPayment: localStorage.getItem('stripeTest'),
      pricesMap: [
        {
          type: 'month',
          id: 'price_1K6amzJfRh4sLA5QkohZIJCI'
        },
        {
          type: 'year',
          id: 'price_1JYleHJfRh4sLA5QqzsAN1do'
        },
      ],
      pricesTestMap: [
        {
          type: 'month',
          id: 'price_1K6arBJfRh4sLA5QnMiKPlEj'
        },
        {
          type: 'year',
          id: 'price_1K6apiJfRh4sLA5QAu1oD5lw'
        },
      ],
    }
  },
  async mounted() {
    this.userCustomer = this.customer;
    this.user = firebase.auth().currentUser;
    /**
     * Getting prices from stripe from our api
     */
    // this.prices = await getPricesFromStripe(this.testPayment)
    fetch(`${API_HOST}/api/config${this.testPayment ? '?test=1' : ''}`).then(async (res) => {
      const pricesResponses = await res.json();
      this.prices = pricesResponses.prices;
    });

    this.stripe = await loadStripe(this.testPayment ? STRIPE_KEY_TEST : STRIPE_KEY);
    const elements = this.stripe.elements();

    cardElement = elements.create('cardNumber');
    cardElement.mount('#card-element');

    cardCvc = elements.create('cardCvc');
    cardCvc.mount('#card-cvc');

    cardExpiry = elements.create('cardExpiry');
    cardExpiry.mount('#card-year');

  },
  methods: {
    async createSub() {
      return createSubscription(this.userCustomer.id, this.selectedPrice.id, this.testPayment, this.trial)
    },
    async createCustomer(methodID = null) {
      const createCustomer = await createCustomerStripe(this.user.email, this.testPayment, methodID);
      if (createCustomer.customer && createCustomer.customer.id) {
        this.userCustomer = createCustomer.customer
        this.$emit('updatesettings', {customer: createCustomer.customer})
      }
    },
    buyPremium: async function () {
      if (!this.premiumPlan) {
        alert('select plan');
        return false;
      }
      this.selectedPrice = this.prices ? this.prices.find((price) => {
        return price.id === this.localPrice.id
      }) : null;

      if (!this.selectedPrice ) {
        alert('selected price not found');
        return false;
      }

      this.isLoading = true
      let isError = false
      if (!this.userCustomer) {
        if (this.trial) {
          const methodObject = await this.stripe
              .createPaymentMethod({
                type: 'card',
                card: cardElement,
              });

          if (methodObject.error) {
            this.isLoading = false
            isError = true
            alert(methodObject.error.message)
          } else {
            await this.createCustomer(methodObject.paymentMethod.id)
          }
        } else {
          await this.createCustomer()
        }
      }
      if(!isError) {
        const createSub = await this.createSub();
        if (createSub.subscriptionId) {
          this.$emit('updatesettings', {stripeSubscriptionId: createSub.subscriptionId})
          if (this.trial) {
            this.isLoading = false;
            addToActiveCampaignPremiumList(this.user.email, this.premiumPlan);
            this.$emit('premiumispurchased');
              if (window.gtag) {
                  window.gtag('event', 'conversion', {
                      'send_to': 'AW-441971167/eX2BCM615psDEN_j39IB',
                      'transaction_id': ''
                  });
              }
            // trial set
          } else {
            this.stripe
              .confirmCardPayment(createSub.clientSecret, {
                payment_method: {
                  card: cardElement,
                }
              })
              .then((result) => {
                if (result.error) {
                  // Show error to your customer
                  alert('error ' + result.error.message);
                  this.isLoading = false
                } else {
                  this.isLoading = false
                  this.$emit('premiumispurchased')
                }
              });
          }
        } else {
          alert('error:' + createSub.error.message);
          this.isLoading = false;
        }
      }

    },
  },
  computed: {
      localPrice() {
        const priceMap = this.testPayment ? this.pricesTestMap : this.pricesMap;
        return priceMap.find(price => price.type === this.premiumPlan);
      }
  },
}
</script>

<style lang="scss">

</style>
